export default "__VITE_ASSET__ZYnqhIeK__"